import styled from 'styled-components';
import {
  subMenuDropdownBackground,
  primaryColorLight,
  primaryColorWeak,
} from '../../config/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${subMenuDropdownBackground};
  padding: 20px 30px;

  table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    font-size: 0.688rem;
    font-weight: 700;
    text-align: center;
    table-layout: fixed;
    word-break: break-word;

    colgroup {
      col:nth-child(1) {
        width: 6%
      }
      col:nth-child(2) {
        width: 25%
      }
      col:nth-child(5) {
        width: 13%
      }
      col:nth-child(6) {
        width: 15%
      }
    }
  }
  td,
  th {
    padding: 15px;
    border: 2px solid ${primaryColorLight};
  }
  th {
    background-color: ${primaryColorWeak};
    font-size: 0.875rem;
  }
  thead > tr:nth-child(2) > th,
  thead > tr:nth-child(3) > th {
    background-color: whiteSmoke;
    padding: 5px;
    font-size: 0.688rem;
    font-weight: 700;
  }

  tr {
    td:first-child {
      width: 5%;
      background-color: whiteSmoke;
    }
  }

  @media print {
  background-color: inherit;
    table {
      th, td {
         padding: 7px;
         overflow: hidden;
      }
    }
  }
`;

export const TableTitle = styled.p`
  width: 100%;
  margin-bottom: 35px;
`;
